/* eslint-disable react/no-array-index-key */
// Dependencies
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';

// Components
import Arrow from './Arrow';
import CardSlide from './CardSlide';

// Images
import '../../../../node_modules/slick-carousel/slick/slick.css';
import '../../../../node_modules/slick-carousel/slick/slick-theme.css';
import scroll from '../../../sass/images/icons/scroll-base.svg';

// Hooks
import useLanguage from '../../hooks/useLanguage';

function SimpleSlider({ contents = [], t }) {
  const [totalItems] = useState(contents.length);
  const { locale } = useLanguage();

  const settings = {
    dots: false,
    infinite: true,
    swipe: false,
    swipeToSlide: false,
    speed: 0,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: false,
    lazyLoad: 'ondemand',
    pauseOnDotsHover: true,
    pauseOnHover: true,
    initialSlide: 0,
    adaptiveHeight: true,
    accessibility: true,
    fade: false,
    nextArrow: <Arrow type="next" />,
    prevArrow: <Arrow type="prev" />,
  };

  return (
    <div>
      <div className="line" />
      <Slider {...settings}>
        {contents.map((content, index) => (
          <CardSlide
            title={t(content.title)}
            classText={`grid-x2-text slider${index + 1}`}
            classGrid={`grid-x2 slider${index + 1}`}
            classImg={`img-slider slider${index + 1}`}
            message={t(content.description)}
            image={content.img}
            alt={content.alt}
            register={t(content.callToAction)}
            number={index + 1}
            key={index}
            totalItems={totalItems}
            path={`/${locale}/${t(`routers:${content.path}`)}`}
          />
        ))}
      </Slider>
      <figure className="icon-scroll">
        <img src={scroll} alt={t('alt:scroll')} />
      </figure>
    </div>
  );
}

SimpleSlider.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation(['slider', 'routers'])(SimpleSlider);
